import { MyCheckbox } from '~/components/ui/MyCheckbox'
import { PretreatmentMethod } from '~/graphqls/types'

interface Props {
  value?: PretreatmentMethod.NONE
  onChange?: (a: any) => void
}

export default function PreProcessSwitch({ value, onChange }: Props) {
  const _innerValue = value !== PretreatmentMethod.NONE
  return (
    <MyCheckbox
      $dark
      checked={_innerValue}
      onChange={e => {
        const checked = e.target.checked
        if (checked) {
          onChange?.(undefined)
        } else {
          onChange?.(PretreatmentMethod.NONE)
        }
      }}
    />
  )
}
